import React, {FC} from 'react';
import {Box, Radio} from '@material-ui/core';

import {Option} from '../../../types';
import {TextEllipsis} from '../../game-select/TextEllipsis';

export interface DatePickerOptionProps extends Pick<Option, 'label' | 'value'> {
    selected: boolean;
    disabled?: boolean;
    onChange: (value: string | number) => void;
}

const DatePickerOption: FC<DatePickerOptionProps> = ({
    value,
    label,
    selected,
    disabled,
    onChange
}: DatePickerOptionProps) => {
    const handleChange = _event => {
        onChange(value);
    };

    return (
        <Box display="flex" alignItems="center" mx={5} my={2} onClick={handleChange}>
            <Radio checked={selected} disabled={disabled} />
            <Box mx={3}>
                <TextEllipsis variant="caption" color="textPrimary">
                    <span>{label}</span>
                </TextEllipsis>
            </Box>
        </Box>
    );
};

export default DatePickerOption;
